import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function LoadingSpinner({ size = "md", className }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-16 h-16",
    lg: "w-24 h-24",
  };

  return (
    <div className={cn("relative", sizeClasses[size], className)}>
      {/* Outer rotating lotus petals */}
      <div className="absolute inset-0 animate-spin">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <path
            d="M50,20 Q60,30 50,40 Q40,30 50,20 M80,50 Q70,60 60,50 Q70,40 80,50 M50,80 Q40,70 50,60 Q60,70 50,80 M20,50 Q30,40 40,50 Q30,60 20,50"
            fill="none"
            stroke="hsl(var(--primary))"
            strokeWidth="2"
            opacity="0.6"
          />
        </svg>
      </div>
      
      {/* Inner pulsing lotus petals */}
      <div className="absolute inset-0 animate-pulse">
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <path
            d="M50,30 Q55,40 50,50 Q45,40 50,30 M70,50 Q60,55 50,50 Q60,45 70,50 M50,70 Q45,60 50,50 Q55,60 50,70 M30,50 Q40,45 50,50 Q40,55 30,50"
            fill="hsl(var(--secondary))"
            opacity="0.8"
          />
        </svg>
      </div>
      
      {/* Center flame/light */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-3 h-3 rounded-full bg-primary animate-pulse shadow-[0_0_10px_hsl(var(--primary))]" />
      </div>
    </div>
  );
}
